export default __webpack_public_path__ + "static/media/p7_game15.22ebdb27.png";